import { render } from "./exam-questions.vue?vue&type=template&id=0936734f&scoped=true"
import script from "./exam-questions.vue?vue&type=script&lang=js"
export * from "./exam-questions.vue?vue&type=script&lang=js"

import "./exam-questions.vue?vue&type=style&index=0&id=0936734f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0936734f"]])

export default __exports__